// extracted by mini-css-extract-plugin
var _1 = "BeastPartBorder__border--pzO8W";
var _2 = "BeastPartBorder__borderButton--ltC5E";
var _3 = "BeastPartBorder__borderWrapper--V7Q2p BeastPartBorder__movable--evbLi";
var _4 = "BeastPartBorder__buttonImg--V46x9";
var _5 = "BeastPartBorder__buttonImgDisabled--dJyoZ BeastPartBorder__buttonImg--V46x9";
var _6 = "BeastPartBorder__isRotating--DZ2d8";
var _7 = "BeastPartBorder__movable--evbLi";
var _8 = "BeastPartBorder__reflecth--O4MEq BeastPartBorder__borderButton--ltC5E";
var _9 = "BeastPartBorder__reflectv--woVJT BeastPartBorder__borderButton--ltC5E";
var _a = "BeastPartBorder__resize--Yv8vr BeastPartBorder__borderButton--ltC5E";
var _b = "BeastPartBorder__rotate--iQECm BeastPartBorder__borderButton--ltC5E";
var _c = "BeastPartBorder__rotateHandler--lBOKH";
var _d = "BeastPartBorder__rotateHandlerDisabled--Zu30T BeastPartBorder__rotateHandler--lBOKH";
var _e = "BeastPartBorder__scaleHandler--Uj6Hz";
export { _1 as "border", _2 as "borderButton", _3 as "borderWrapper", _4 as "buttonImg", _5 as "buttonImgDisabled", _6 as "isRotating", _7 as "movable", _8 as "reflecth", _9 as "reflectv", _a as "resize", _b as "rotate", _c as "rotateHandler", _d as "rotateHandlerDisabled", _e as "scaleHandler" }
